import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import Blankprof from "../assets/blankProf.png";
import { IoMdSettings } from "react-icons/io";
import { UserAuth } from "../context/authContext";
import { db } from "../firebase-config";
import "../style.css";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  collectionGroup,
  where,
  query,
} from "firebase/firestore";
import { AiOutlineSearch } from "react-icons/ai";

export default function Pagetop(props) {
  const { user } = UserAuth();
  const [picture, setPicture] = useState("");

  const getUserImage = async () => {
    const userRef = doc(db, "users", user.uid);

    await getDoc(userRef).then((docSnap) => {
      setPicture(docSnap.data().profilePic);
    });
  };

  useEffect(() => {
    getUserImage();
  }, []);

  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);

  const getUsers = async () => {
    if (search.length > 0) {
      const Usersquery = query(
        collectionGroup(db, "users"),
        where("NameAsArray", "array-contains", search)
      );

      const querySnapshot = await getDocs(Usersquery);

      console.log(querySnapshot.docs);

      let tempUsers = [];

      querySnapshot.forEach((user) => {
        tempUsers.push({ id: user.id, data: user.data() });
      });

      setResults(tempUsers);
    } else {
      setSearch("");
      setResults([]);
    }

    if (search.length == 0) {
      setSearch("");
      setResults([]);
    }
  };

  useEffect(() => {
    getUsers();
  }, [search]);

  let navigator = useNavigate();

  const profChange = (name, userID) => {
    const first = name.split(" ");

    const replaced = first.join("");
    const nav = `/profile/@${replaced}`;
    navigator(nav, { state: { userID: userID } });
  };

  return (
    <div
      className={
        props.bg === "transparent"
          ? "topWrapper bg-transparent z-50"
          : "topWrapper bg-[#161616] z-50"
      }
    >
      <h2 className="capitalize">{props.title}</h2>
      <div className="flex flex-row items-center">
        <div className="w-64 h-9 mr-3 flex flex-row items-center bg-[#202020] rounded-lg pr-2 relative">
          <input
            type="text"
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
            className="h-full w-full rounded-lg bg-[#202020] placeholder:text-zinc-600 pl-2 focus:outline-none text-zinc-200"
            placeholder="Search"
            value={search}
          />
          <AiOutlineSearch size={25} className="fill-zinc-600" />
          <div className="absolute w-full top-12 rounded-xl bg-[#202020] flex justify-center items-center overflow-hidden">
            {results.length > 0 ? (
              <div className="w-full flex flex-col">
                {search.length > 0 &&
                  results.map((res, index) => {
                    return (
                      <div
                        className="w-full py-2 px-2 text-sm capitalize flex flex-row font-semibold items-center hover:bg-[#181818] transition-all ease-in-out cursor-pointer"
                        key={index}
                        onClick={() => {
                          profChange(res.data.username, res.id);
                          setSearch("");
                        }}
                      >
                        <div className="w-10 h-10 rounded-full overflow-hidden mr-2">
                          <img
                            src={res.data.profilePic}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        {res.data.username}
                      </div>
                    );
                  })}
              </div>
            ) : (
              <div className={search.length > 0 ? "py-2" : ""}>
                {search.length > 0 && "No results found"}
              </div>
            )}
          </div>
        </div>
        <NavLink to="/account">
          <IoMdSettings
            size={35}
            className="fill-IconHover transition ease-in-out hover:scale-110"
          />
        </NavLink>
        <NavLink
          to="/profile"
          className="ml-4 h-14 w-14 rounded-full overflow-hidden flex items-center justify-center"
        >
          {picture ? (
            <img
              src={picture}
              referrerPolicy="no-referrer"
              className="rounded-full object-cover w-full h-full scale-x-125"
            />
          ) : (
            <img src={Blankprof} className="invisible" />
          )}
        </NavLink>
      </div>
    </div>
  );
}
